export interface AccountingSheetInterface {
  status: AccountingSheetStatus;
  number: string;
  startDate: string;
  finishDate: string;
  supplierId: number;
  supplierName: string;
  // Отдаёт карточка листа; нужна форме претензии, чтобы сверить площадку листа (задача 10833).
  platformId?: number | null;
  totalWithoutTax: number;
  taxAmount: number;
  // Ставка НДС, % (целое 0–100); может отсутствовать в данных листа
  tax?: number | null;
  total: number;
  documents: DataForDocumentLink[];
  jbpmProcessId: number;
  jbpmContainerId: string;
  accountDate: string | null;
  documentDate: string | null;
  invoiceNumber: string | null;
  accountNumber: string | null;
  id: number;
  groups: any[];
  comment: string | null;
  fmLegalCode: string;
  contractNumber: string;
  contractDate: string;
  contractPaymentPeriod: string;
  contractPaymentPeriod2: number;
  // Комплекты, отклонённые кнопкой «Отклонить комплект»: пока список не пуст, присланный архив не принимается.
  rejectedPackages?: { rejectedAt: string | null; rejectedBy: string | null; rejectComment: string | null }[];
}

interface DataForDocumentLink {
  bucket: string;
  objectName: string;
  type: string | null;
  /**
   * Исход сверки файла, присланного поставщиком, с нашей версией листа:
   * identical (совпал), content_equal (данные те же, файл оформлен иначе),
   * differs (расхождения). null — документ сверку не проходил.
   */
  compareResult: string | null;
  /**
   * Отметка отказа от файла поставщика: время в UTC, «ФИО (роль)», причина. У zip —
   * отметка листа учёта, который в нём пришёл. null — файл не отклоняли.
   */
  rejectedAt?: string | null;
  rejectedBy?: string | null;
  rejectComment?: string | null;
  /** Согласие с изменённым файлом поставщика: время в UTC, «ФИО (роль)». null — согласия нет. */
  acceptedAt?: string | null;
  acceptedBy?: string | null;
  /** Чем файл поставщика отличается от нашего листа. null — у документа сверки не было. */
  compareDetails?: CompareDetails | null;
}

export interface SupplierChangeCell {
  cell: string;
  old: string | null;
  new: string | null;
}

/**
 * Расхождения файла поставщика: первые ячейки (адрес «Лист!B4», было, стало) и их общее
 * число, изменение состава листов книги, причина, по которой файл не прочитан.
 */
export interface CompareDetails {
  cells: SupplierChangeCell[];
  cellCount?: number;
  sheetsNote?: string | null;
  unreadable?: { reason: string; error: string | null } | null;
}

export enum AccountingSheetStatus {
  CREATED = 'created',
  CONTROLLING_APPROVAL_AWAIT = 'controlling_approval',
  ACCOUNTANT_APPROVAL_AWAIT = 'accounting_approval',
  PAYMENT_AWAIT = 'payment_await',
  PAYMENT_DONE = 'payment_done',
  SUPPLIER_CONFIRMATION_AWAIT = 'supplier_confirmation',
  // Поставщик прислал лист учёта с изменениями: кадры или контроллинг соглашаются
  // с ними или отказываются, после отказа лист снова ждёт архив.
  SUPPLIER_CHANGES_APPROVAL = 'supplier_changes_approval',
  DIADOC_SIGNING_AWAIT = 'diadoc_signing_await',
  // Приходит с бэка после подписи подписантом, пока идёт документооборот в
  // Диадоке. В списке листов — своя колонка.
  SIGNED_BY_SIGNER = 'signed_by_signer',
  PROBLEM = 'problem',
  RECALLED = 'recalled',
}
